import { MouseEvent, ReactElement, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import Dropdown from 'components/v2/Dropdown'
import List from 'components/v2/List'
import { DotsIcon } from 'components/Icons/DotsIcon'
import IconButton from 'components/v2/IconButton'
import { IRoutingProjectPlanOptimizationRoute } from 'features/RoutingProjects/types'
import { useSidebarContext } from 'features/RoutingProjects/components/RoutingProjectSidebar'

interface IRouteActionsProps {
  setIsOpenAddStopModal: (isOpen: boolean) => void
  route: IRoutingProjectPlanOptimizationRoute
}

export const RouteActions = ({ setIsOpenAddStopModal, route }: IRouteActionsProps): ReactElement => {
  const [isOpenDropdown, setOpenDropdown] = useState(false)
  const { handleShowRouteInOverlay } = useSidebarContext()

  const toggleDropdown = (event: MouseEvent): void => {
    event.stopPropagation()

    setOpenDropdown(!isOpenDropdown)
  }

  const handleOpenAddStopModal = (event: MouseEvent): void => {
    event.stopPropagation()
    if (!route.isLocked) {
      setIsOpenAddStopModal(true)
      setOpenDropdown(false)
    }
  }

  const handleAddRouteToSidebarOverlay = (event: MouseEvent): void => {
    event.stopPropagation()
    handleShowRouteInOverlay(route.id)
    setOpenDropdown(false)
  }

  return (
    <>
      <Dropdown.Wrapper noPadding noIndicator onClickAway={(): void => setOpenDropdown(false)}>
        <IconButton icon={<DotsIcon />} onClick={toggleDropdown} noBorder smallPadding />
        <Dropdown.Content open={isOpenDropdown} noIndicator right>
          <List.Container>
            <List.Item action onClick={handleOpenAddStopModal} disabled={route.isLocked}>
              <FormattedMessage id="routingProjectSidebar.optimizedRoutesList.addStop" defaultMessage="Add stop" />
            </List.Item>
            <List.Item action onClick={handleAddRouteToSidebarOverlay}>
              <FormattedMessage
                id="routingProjectSidebar.optimizedRoutesList.addToSidebarOverlay"
                defaultMessage="Move to second column"
              />
            </List.Item>
          </List.Container>
        </Dropdown.Content>
      </Dropdown.Wrapper>
    </>
  )
}
